import React from 'react';
import { Alert, ErrorPage as RecessErrorPage } from '@guildeducationinc/recess';
import { useHistory } from 'react-router-dom';
import { useAuth } from '@guildeducationinc/guild-auth';
import { datadogRum } from '@datadog/browser-rum';
import RequestSupportButton from '@shared/RequestSupportButton/RequestSupportButton';

interface ErrorProps {
  children?: React.ReactNode;
  message?: string;
  title?: string;
  subtitle?: string;
  support?: boolean;
  error?: boolean;
  authError?: boolean;
  errorMessage?: string;
}

export const ERROR_MESSAGE = 'There was a problem loading that page.';

export const errorItemHeading = (errorMessage?: string) =>
  `A user landed on the error page: ${errorMessage}`;

const ErrorPage: React.FC<ErrorProps> = ({
  children,
  message = ERROR_MESSAGE,
  title,
  error = false,
  errorMessage,
  authError = false,
  subtitle,
  support,
}) => {
  const { push } = useHistory();
  const { user, logout } = useAuth();
  // replaceAll isn't available in es5 - if we set our target to esnext in tsconfig we can use it
  errorMessage = errorMessage?.split('+').join(' ');

  function handleGoBack() {
    if (!user) {
      logout();
    } else {
      push('/');
    }
  }

  const ERROR_HEADING = errorItemHeading(errorMessage);

  if (authError) {
    datadogRum.addError(ERROR_HEADING, {
      type: 'warning',
    });
  } else {
    datadogRum.addError(ERROR_HEADING);
  }

  return (
    <RecessErrorPage title={title} subtitle={subtitle} message={message} goBack={handleGoBack}>
      <div className='errorPage-childContainer'>
        {children}

        <Alert
          className='margin--y_24'
          display={error}
          hideClose
          message={errorMessage ?? 'Error'}
          type='danger'
        />
        {support && <RequestSupportButton />}
      </div>
    </RecessErrorPage>
  );
};

export default ErrorPage;
